import Box from '@mui/material/Box';
import type { SxProps, Theme } from '@mui/material/styles';

import NotificationBell from './Notifications/components/NotificationBell';
import CommunicationIconComponent from './CommunicationPopper/components/CommunicationIconComponent';
import { HeaderBar } from './headerComponents/HeaderBar';
import { HomeLogoButton } from './headerComponents/HomeLogoButton';
import { PlantAlarmTriggerControl } from './headerComponents/PlantAlarmTriggerControl';
import { ProfileMenuControl } from './headerComponents/ProfileMenuControl';
import { VatikaBadge } from './headerComponents/VatikaBadge';
import { useHeaderActions } from './headerComponents/useHeaderActions';

const actionsSx: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  gap: { xs: 1, md: 2 },
  minWidth: 0,
  marginInlineStart: 'auto',
};

export default function Header(): JSX.Element {
  const { isStaff, isViewing, showVatikaLogo } = useHeaderActions();

  return (
    <HeaderBar>
      <HomeLogoButton />
      <Box sx={actionsSx}>
        {isStaff && <PlantAlarmTriggerControl />}
        <NotificationBell key={String(isViewing)} />
        <CommunicationIconComponent />
        <ProfileMenuControl />
      </Box>
      {showVatikaLogo && <VatikaBadge />}
    </HeaderBar>
  );
}
